const Page = require('../components/Page');
const Menu = require('../components/Menu');

Page.create('.front', () => {
  Menu.create('.menu-name-menu-hero');
});
